import { Pipe, PipeTransform } from '@angular/core';
import { PermitSummary } from 'src/app/services/permit-summary.service';

@Pipe({ name: 'permitSummaryFilter' })
export class PermitSummaryFilterPipe implements PipeTransform {
  transform(values: PermitSummary[], filter: string): PermitSummary[] {
    if (!filter)
      return values;
    const term = filter.toLowerCase();
    return values.filter(item =>
      !!item && (
        this.checkValue(item.applicationPackageId, term)
        || this.checkValue(item.waterRightsId, term)
        || this.checkValue(item.permitStatus, term)
        || this.checkValue(item.permitYear, term)
        || this.checkValue(item.permitStartDateFormatted, term)
        || this.checkValue(item.permitEndDateFormatted, term)
        || this.checkValue(item.appropriatorName, term)
        || this.checkValue(item.diversionName, term)
      )
    );
  }

  checkValue(value: any, filter: string) {
    return !!value && value.toString().toLowerCase().includes(filter);
  }
}
